import $public from '../../util/public.js'
export default {
	namespaced: true,
	state: {
		type:'list',
		addParams:{},
		money:0,
		activityMoney:0,
		vipMoney:0,
		remark:'',
	},
	getters: {
		
	},
	mutations: {
		set_type(state, params) {
			state.type = params;
		},
		set_addParams(state, obj) {
			state.addParams = obj;
			if(obj&&obj.pets_list){
				state.money = 0;
				state.vipMoney = 0;
				state.activityMoney = 0;
				for(let i=0;i<obj.pets_list.length;i++){
					let item = obj.pets_list[i]
					state.money = $public.jia(state.money,item.price)
					state.vipMoney = $public.jia(state.vipMoney,item.mprice>0?item.mprice:item.price)
					state.activityMoney = $public.jia(state.activityMoney,item.activityPrice)
				}
			}
		},
		set_remark(state, obj) {
			state.remark = obj;
		},
	},
	actions: {

	},
};
